const formatReports = (payload) => {
  if (payload.reports[0].data.rows === undefined) {
    return undefined;
  }
  const data = payload.reports[0].data.rows.filter((row) => row.dimensions[0] !== '(not set)').splice(0, 10);
  const formattedData = [];

  data.forEach((item, index) => {
    const position = index;
    const region = item.dimensions[0];
    const city = item.dimensions[1];
    const lat = item.dimensions[2];
    const lng = item.dimensions[3];
    const newUsers = item.metrics[0].values[0];
    const data = {
      position,
      region,
      city,
      lat,
      lng,
      newUsers,
    };

    formattedData.push(data);
  });

  return formattedData.reverse();
};

export const google_analytics_visitor_middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (action.type === 'CRM_FETCH_ANALYTICS_USER_LOCATIONS') {
      let formattedData = formatReports(action.payload);
      action.payload = formattedData;
    }

    next(action);
  };
